import React, { Component } from 'react';
import PropTypes from 'prop-types'
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, withStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import Groups from './Home/Groups'
import AddGroup from './Home/Add Group'
import '../App.css'
import { GoSignOut } from "react-icons/go";
import firebase from '../Config/Firebase'
import Logout from './Home/logout.svg'



var auth = 0

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(1),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(7),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    searchinput: {
        margin: "300px",
    },

    inputInput: {
        padding: theme.spacing(1, 1, 1, 7),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
});

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            left: false,
            page: "Groups",
            show: false,
            search: "",
            auth: true
        }
    }

    send(to) {

        this.setState({ page: to })
    }



    sideList = side => {

        return (
            <div
                className="drawer"
                role="presentation"
                onClick={() => { this.toggleDrawer(side, false) }}
                onKeyDown={() => { this.toggleDrawer(side, false) }}
            >

                <div>





                    <img src={require('../assets/Summitlogo.jpg')} width={250} />

                    <List>



                        <ListItem button key="Groups" onClick={() => { this.send("Groups") }}>
                            <ListItemIcon >{<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 18 18"><path d="M6 8c1.11 0 2-.9 2-2s-.89-2-2-2c-1.1 0-2 .9-2 2s.9 2 2 2zm6 0c1.11 0 2-.9 2-2s-.89-2-2-2c-1.11 0-2 .9-2 2s.9 2 2 2zM6 9.2c-1.67 0-5 .83-5 2.5V13h10v-1.3c0-1.67-3.33-2.5-5-2.5zm6 0c-.25 0-.54.02-.84.06.79.6 1.34 1.4 1.34 2.44V13H17v-1.3c0-1.67-3.33-2.5-5-2.5z" /></svg>}</ListItemIcon>
                            <ListItemText primary="Groups" />
                        </ListItem>

                        <ListItem button key="Add Group" onClick={() => { this.send("Add Group") }}>
                            <ListItemIcon>{<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 18 18"><path d="M9 8c1.11 0 2-.9 2-2s-.89-2-2-2c-1.1 0-2 .9-2 2s.9 2 2 2zm4 0c1.11 0 2-.9 2-2s-.89-2-2-2c-.36 0-.69.1-.98.27.3.51.48 1.1.48 1.73s-.18 1.22-.48 1.73c.29.17.63.27.98.27zM9 9.2c-1.67 0-5 .83-5 2.5V13h10v-1.3c0-1.67-3.33-2.5-5-2.5zM5 7H3V5H2v2H0v1h2v2h1V8h2V7zm9.23 2.31c.75.6 1.27 1.38 1.27 2.39V13H18v-1.3c0-1.31-2.07-2.11-3.77-2.39z" /></svg>}</ListItemIcon>
                            <ListItemText primary="Add Group" />
                        </ListItem>

                        <ListItem button key="Logout" onClick={this.props.logout}>
                            <ListItemIcon>{<GoSignOut color="#000" size='1.3em' />}</ListItemIcon>
                            <ListItemText primary="Logout" />
                        </ListItem>

                    </List>

                </div>
            </div>)
    }

    toggleDrawer = () => {

        this.setState({ left: !this.state.left });
        this.setState({ show: false })
    };



    checkuser = () => {
        var self = this

        firebase.auth().onAuthStateChanged((user) => {
            if (user) {

            } else {
                //console.log("user is not present")
                self.props.timedout()
            }

        })



    }




    render() {
        const { classes } = this.props;
        return (
            <div>




                <div className={classes.root}>
                    <AppBar position="static"
                        children={
                            <input />
                        }>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                className={classes.menuButton}
                                color="inherit"
                                aria-label="open drawer"
                                onClick={this.toggleDrawer}
                            >
                                <MenuIcon />
                            </IconButton>
                            <Typography className={classes.title} variant="h4" noWrap>
                                {this.state.page}
                            </Typography>

                            {this.state.page === "Groups" && <div className={classes.search}>
                                <div className={classes.searchIcon}>
                                    <SearchIcon />
                                </div>
                                <InputBase
                                    onChange={(e) => { this.setState({ search: e.target.value }) }}
                                    placeholder="Search…"
                                    classes={{
                                        root: classes.inputRoot,
                                        input: classes.inputInput,
                                    }}
                                    inputProps={{ 'aria-label': 'search' }}
                                />
                            </div>}
                        </Toolbar>
                    </AppBar>
                </div>

                <Drawer open={this.state.left} onClose={() => { this.toggleDrawer('left', false) }} className="drawer">
                    {this.sideList('left')}
                </Drawer>

                {this.state.page === "Groups" && <Groups status={this.state.page} value={this.state.show} search={this.state.search} timedout={this.props.timedout} />}
                {this.state.page === "Add Group" && <AddGroup />}

            </div>


        )
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);